import React, { useState, useEffect } from 'react';
import { useSSRSelector } from 'src/redux';
import { specificThemeRender } from 'src/utils/specificThemeRender';
import { getThemeComponent } from 'src/utils/themeImports';
import BlogCard1 from '@/components/BlogListing/BlogCard';

export default function BlogListing(props) {
  const { storeInfo, catalogCategories } = useSSRSelector((state) => ({
    storeInfo: state.storeReducer.store,
    catalogCategories: state.catalogReducer.categories,
  }));
  const [state, setState] = useState({ pages: {} });

  useEffect(() => {
    setState({ pages: props?.pages });
  }, [props]);

  const onWrapperClick = (dataReceived) => {
    if (props.onElementClick) {
      props.onElementClick({ ...dataReceived, templateId: props.templateId });
    }
  };

  const onViewMoreBtnClick = () => {
    if (state.section?.slug) {
      const link = window.location.href.split('');
      const ifLastCharSlash = link[link.length - 1] === '/';
      window.location.href = `${window.location.href}${ifLastCharSlash ? '' : '/'}${state.section?.slug}`;
    }
  };

  return (
    <div className="relative">
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          storeData: storeInfo,
          categories: catalogCategories || [],
          ...layout,
        });
      })}
      <div id="blog_section_1" className="blog-main-container">
        <div
          id="section_title"
          className={`black section-title tc`}
          onClick={() =>
            onWrapperClick({
              parentKey: '',
              itemIndex: null,
              keyToBeUpdated: 'section_title',
              childKeyToBeReplaced: 'display_text',
            })
          }
        >
          <span className="fw6 heading">Our Blogs</span>
        </div>
        <div className="tw-flex tw-flex-wrap tw-justify-center">
          {props?.blogList?.map((blogData) => (
            <BlogCard1 {...blogData} key={blogData?.page_id} />
          ))}
        </div>
        {state.pages?.length > 10 ? (
          <section className="flex justify-center items-center view-more-btn--container">
            <button onClick={onViewMoreBtnClick} className="view-more-btn">
              <span className="w-100 tc">View More</span>
            </button>
          </section>
        ) : null}
      </div>
      {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          storeData: storeInfo,
          categories: catalogCategories || [],
          ...layout,
        });
      })}
    </div>
  );
}
